/* global SERVER_URL */
import ExtendableError from 'es6-error';
import 'isomorphic-fetch';

class NotifyingError extends ExtendableError {
  constructor(message = 'Explore.org System Error') {
    super(message);
  }

  notify(message = this.message, id, data = {}) {
    return fetch(`${SERVER_URL}/system-alerts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, iterationId: id, data }),
    })
    .then(res => res.status === 201)
    .catch(err => console.err(err));
  }
}

export default NotifyingError;
